<ion-content class="share-modal ion-padding">
  <div class="share-modal-container">
    <h3 class="title">{{ modalTitle | translate }}</h3>

    <div class="message-box">
      <p class="message-text">{{ message }}</p>
      @if (link) {
      <a class="share-link" [href]="link" target="_blank" rel="noopener">{{ link }}</a>
      }
    </div>

    @if (isNative) {
    <div class="copy-divider"></div>
    <button type="button" class="native-share-button" (click)="onNative()">
      <span class="icon-circle">
        <img src="assets/icons/share-icon.svg" class="option-icon" alt="" />
      </span>
      <span class="copy-text">{{ 'share.share-message' | translate }}</span>
    </button>
    } @else {
    <div class="share-buttons">
      @if (hasChannel('whatsapp')) {
      <button type="button" class="share-button" (click)="onWhatsApp()">
        <img src="assets/icons/whatsapp-icon.svg" alt="" />
        <span>{{ 'share-buttons.whatsapp' | translate }}</span>
      </button>
      }
      @if (hasChannel('instagram')) {
      <button type="button" class="share-button" (click)="onInstagram()">
        <img src="assets/icons/instagram-icon.svg" alt="" />
        <span>{{ 'share-buttons.instagram' | translate }}</span>
      </button>
      }
      @if (hasChannel('email')) {
      <button type="button" class="share-button" (click)="onEmail()">
        <img src="assets/icons/correo-icon.svg" alt="" />
        <span>{{ 'share-buttons.email' | translate }}</span>
      </button>
      }
      @if (hasChannel('copy')) {
      <button type="button" class="share-button" (click)="onCopy()">
        <img src="assets/icons/copylink-icon.svg" alt="" />
        <span>{{ 'share-buttons.copy' | translate }}</span>
      </button>
      }
    </div>
    }
  </div>
</ion-content>
